import CheckList from './CheckList';
import HeaderMenu from '../menu/HeaderMenu'
import FooterMenu from '../menu/FooterMenu'

const Check = ({...props }) => {
    return (
        <div>
            <HeaderMenu />
            <CheckList />
            <FooterMenu />
        </div>
    );
};

export default Check;